import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AdminBookings from "./pages/AdminBookings";
import AdminGate from "./components/AdminGate";
import MyBooking from "./pages/MyBooking";
import Receipt from "./pages/Receipt";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/bookings" element={<AdminGate><AdminBookings /></AdminGate>} />
          <Route path="/my-booking" element={<MyBooking />} />
          <Route path="/receipt/:bookingId" element={<Receipt />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
